import React from 'react';

//image
import vinaphoneplus_logo from 'assets/imgs/LandingVNPPlus/vinaphoneplus_logo.png';
import vnpplus_banner_landing from 'assets/imgs/LandingVNPPlus/vnpplus_banner_landing.png';
import present_box from 'assets/imgs/LandingVNPPlus/Present-box.png';
import vnpt_icon from 'assets/imgs/LandingVNPPlus/VNPT.png';

import './style.scss';
import { Button } from 'components';
import { env_set } from 'global/environment';

const LandingVNPPlus = () => {
    
    const urlMyVNPTVplus = () => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        if (
            userAgent.match(/iPad/i) ||
            userAgent.match(/iPhone/i) ||
            userAgent.match(/iPod/i)
        ) {
            if (env_set == 3) {
                return "https://my.vnpt.com.vn/app?screenCode=VNPPLUS&u=vplus"
            } else {
                return "https://stagingv2.myvnpt.com.vn/app?screenCode=VNPPLUS&u=vplus"
            }
        } else if (userAgent.match(/Android/i)) {
            return "https://my.vnpt.com.vn/app?screenCode=VNPPLUS&u=vplus"
        } else {
            return "https://my.vnpt.com.vn/tinh-nang/ung-dung"
        }
    }
    const navVPlus = () => {
        let url = urlMyVNPTVplus()
        window.location.assign(url)
    }
    return (
        <div id="vinaphone_plus-landing">
            <div className='wrapper'>
                <div className='banner'>
                    <img src={vnpplus_banner_landing} alt="" srcset="" />
                </div>
                <div className='logo_top'>
                    <div className='wrapper'>
                        <img src={vinaphoneplus_logo} alt="" srcset="" />
                        <div className='title'>VinaPhone Plus</div>
                    </div>
                </div>
                <div className='warning-title'>
                    <span>Thông báo</span>
                    <span>Chuyển đổi ứng dụng VinaPhone Plus</span>
                    <span>Sang ứng dụng My VNPT</span>
                </div>
                <div className='access-myvnpt-button'>
                    <div className='wrapper'>
                        <Button id="button-myvnpt" onClick={navVPlus}>Truy cập My VNPT</Button>
                        <div className='date'>Từ ngày 15.06.2024</div>
                    </div>
                </div>
                <div className='content'>
                    <div className='title'>Bắt đầu từ ngày 20/06/2024, để nhận điểm thưởng, e-voucher, đổi điểm lấy quà tặng, Hội viên thực hiện theo hai bước sau:</div>
                    <div className='steps'>
                        <div className='logo_wrapper'>
                            <img src={vnpt_icon} alt="" />
                        </div>
                        <div className='content_wrapper'>
                            <div className='title'>Bước 1: Tải ứng dụng</div>
                            <div className='content-detail'>Hội viên tải và đăng nhập trên ứng dụng <a href={urlMyVNPTVplus()}>My VNPT </a></div>
                        </div>
                    </div>
                    <div className='steps'>
                        <div className='logo_wrapper'>
                            <img src={present_box} alt="" />
                        </div>
                        <div className='content_wrapper'>
                            <div className='title'>Bước 2: Trải nghiệm</div>
                            <div className='content-detail'>Truy cập mục VinaPhone Plus, lựa chọn phần quà yêu thích và bấm nút nhận ưu đãi.</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LandingVNPPlus;